import React from 'react';
import {connect} from 'react-redux';
import Autosuggest from 'react-autosuggest';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import {activateLayer, displayDetailPanel, zoomMapToExtent} from '../../../actions';
import DebounceInput from 'react-debounce-input';
import {ReactSVG} from 'react-svg';
import self from '../../../apis/self';
import {trans} from '../../../config/translation';
import {pushGtmSearchArea} from '../../../config/gtm';

/**
 * Area Search on navbar
 * map will jump to designated area extent
 * area search will auto suggest the value of the area
 */
class AreaSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value      : '',
            suggestions: []
        };

        this.debouncedLoadSuggestions = _.debounce(this.getSuggestions, 1000);
    }

    onChange = (event, {newValue}) => {
        this.setState({
            value: newValue
        });
    }

    // https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    /**
     * autosuggest to get sugestions
     *
     * @param value
     * @returns {{areas: *, title: (string)}[]|*[]}
     */
    getSuggestions(value) {
        const escapedValue = this.escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }

        /* regex  matching from 1st character of each word*/
        const regex = new RegExp('\\b' + escapedValue, 'i');

        return areas
            .map(section => {
                return {
                    title: section.title,
                    areas: section.areas.filter(area => regex.test(area.name))
                };
            })
            .filter(section => section.areas.length > 0);
    }

    /**
     *  autosuggest get value from sugestion
     * @param suggestion
     * @returns {*}
     */
    getSuggestionValue(suggestion) {
        return suggestion.name;
    }

    /**
     * render suggestion item
     *
     * @param suggestion
     * @param query
     * @returns {*}
     */
    renderSuggestion(suggestion, {query}) {
        const suggestionText = suggestion.name;
        const matches = AutosuggestHighlightMatch(suggestionText, query);
        const parts = AutosuggestHighlightParse(suggestionText, matches);

        return (
            <span className="area">
            {
                parts.map((part, index) => {
                    const className = part.highlight ? 'highlight' : null;

                    return (
                        <span className={className} key={index}>{part.text}</span>
                    );
                })
            }
            </span>
        );
    }

    /**
     * render suggestion title
     *
     * @param section
     * @returns {*}
     */
    renderSectionTitle(section) {
        return (
            <span>{section.title}</span>
        );
    }

    /**
     * render suggestion container with perfectScollbar
     *
     * @param containerProps
     * @param children
     * @param query
     * @returns {*}
     */
    renderSuggestionsContainer({containerProps, children, query}) {
        if(window.outerWidth > 1023){
            return (
                <PerfectScrollbar className="suggestion-ps-container" {...containerProps}>
                    {children ? children : ''}
                </PerfectScrollbar>
            )
        }
        else{
            return (
                <div className="suggestion-ps-container" {...containerProps}>
                    {children ? children : ''}
                </div>
            )
        }
    }

    /**
     * When rendering multiple sections, you need to tell Autosuggest where to find the suggestions for a given section.
     *
     * @param section
     * @returns {HTMLCollection}
     */
    getSectionSuggestions(section) {
        return section.areas;
    }

    /**
     * apply minimum character before suggestion starts
     *
     * @param value
     * @returns {boolean}
     */
    shouldRenderSuggestions(value) {
        return value.trim().length >= 3;
    }

    /**
     * Autosuggest will call this function every time you need to update suggestions.
     *
     * @param value
     */
    onSuggestionsFetchRequested = ({value}) => {
        self.get('/boundaries/search?q='+value, {
            timeout: 40000
        }).then((response) => {
            this.setState({
                suggestions: response.data
            });
        }).catch((error) => {
            console.log(error);
        });
        // console.log(this.getSuggestions(value));
        // this.setState({
        //     suggestions: this.getSuggestions(value)
        // });
    }

    /**
     * Autosuggest will call this function every time you need to clear suggestions.
     *
     */
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    }

    /**
     * Auto suggest will call this function every time sugesttion clicked
     * will do zoom map to extent
     *
     * @param event
     * @param suggestion
     * @param suggestionValue
     * @param suggestionIndex
     * @param sectionIndex
     * @param method
     */
    onSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        this.props.zoomMapToExtent(suggestion.extent);
        const sectionTitle =  this.state.suggestions[sectionIndex].title.toLowerCase();
        let sectionId = 0;

        if(sectionTitle === 'khg'){
            sectionId =  parseInt(process.env.MIX_MAP_KHG_LAYER_ID);
        }
        else if(sectionTitle === 'kabupaten'){
            sectionId =  parseInt(process.env.MIX_MAP_KABUPATEN_LAYER_ID);
        }
        else if(sectionTitle === 'kecamatan'){
            sectionId =  parseInt(process.env.MIX_MAP_KECAMATAN_LAYER_ID);
        }
        else if(sectionTitle === 'desa'){
            sectionId =  parseInt(process.env.MIX_MAP_DESA_LAYER_ID);
        }
        $('body').find('#location-search-dropdown-menu').removeClass('show');
        this.props.layers.map((layerGroup)=>{
            layerGroup.layers.map(layer => {
                if (layer.id === sectionId) {
                    const isActiveLayer = this.props.activeLayers.find(activeLayer => activeLayer.id === sectionId);
                    if (!isActiveLayer) {
                        this.props.activateLayer(layer);
                    }
                    /* display right panel*/

                    if (sectionId === parseInt(process.env.MIX_MAP_KHG_LAYER_ID)) {
                        if (suggestion.gid !== null && suggestion.gid !== '') {
                            self.post('/layer-detail/khg', {
                                id: suggestion.gid
                            })
                                .then((response) => {
                                    if (_.isEmpty(response.data)) {
                                        this.props.displayDetailPanel({
                                            status: true,
                                            type  : 'utility',
                                            data  : {
                                                message: 'Data not available.',
                                            },
                                        })
                                    } else {
                                        this.props.displayDetailPanel({
                                            status  : true,
                                            type    : 'khg',
                                            data    : response.data,
                                            layerId : sectionId,
                                            isSearch: true,
                                            // feature: data,
                                        });
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                    this.props.displayDetailPanel({
                                        status: true,
                                        type  : 'utility',
                                        data  : {
                                            message: "Oops. there's a problem.",
                                        },
                                    });
                                });
                        }
                    }
                }
            });
        });

        /* gtm event processing */
        pushGtmSearchArea();
    }

    render() {
        const {value, suggestions} = this.state;
        const inputProps = {
            // placeholder: "Cari kabupaten, kecamatan, desa / KHG",
            value,
            onChange   : this.onChange,
            className  : "form-control"
        };

        const renderSearchInput = (inputProps) => (
            <DebounceInput
                placeholder={trans('nav.find-location.location-input-placeholder')}
                minLength={1}
                debounceTimeout={500}
                autoFocus
                {...inputProps}
            />
        );

        return (
            <div className="input-group">
                <Autosuggest className="map-search"
                             multiSection={true}
                             suggestions={suggestions}
                             onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                             onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                             getSuggestionValue={this.getSuggestionValue}
                             renderSuggestion={this.renderSuggestion}
                             renderSectionTitle={this.renderSectionTitle}
                             renderSuggestionsContainer={this.renderSuggestionsContainer}
                             getSectionSuggestions={this.getSectionSuggestions}
                             shouldRenderSuggestions={this.shouldRenderSuggestions}
                             onSuggestionSelected={this.onSuggestionSelected}
                             inputProps={inputProps}
                             renderInputComponent={renderSearchInput}
                             focusInputOnSuggestionClick={false}

                />
                <div className="input-group-append">
                    <ReactSVG className="location-finder-icon react-svg"
                              src="/img/maps/icon/location.svg"/>
                </div>
            </div>
        );
    }
}

const mapActionToProps = {
    zoomMapToExtent,
    activateLayer,
    displayDetailPanel
};

const MapStateToProps = (state) => {
    return {
        layers: state.layers,
        activeLayers: state.activeLayers,
    };
};

export default connect(MapStateToProps, mapActionToProps)(AreaSearch);